export default __webpack_public_path__ + "static/media/logo_komora_800.f6664550.png";